import Button from '@doordash/component-button'
import { Icon, Inline, Text } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import { Application } from 'src/utilities/application/application'
import {
  ANDROID_CLOSE_DEEPLINK,
  ANDROID_REDCARD_DEEPLINK,
  IOS_CLOSE_DEEPLINK,
  IOS_REDCARD_DEEPLINK,
} from '../../../constants'
import * as events from '../../../events'
import { detectWebviewOs } from '../../../utilities/userAgent'
import { OsTypes } from '../../../webview/types'
import RedCardActivate from '../../molecules/redcard-activate'
import t from './strings'
import { CloseButton, NavBar, NavIcon, Wrapper } from './styles'

type RedCardProps = {
  uniqueLink: string
  dasherId: string
  application: Application
  experiments?: any
  returnLink?: () => void | string
  trackRedCardActivateClosed?: () => Promise<any>
}

export class RedCard extends React.Component<RedCardProps> {
  public state = {
    needsActivation: false,
  }

  public render() {
    const { dasherId, returnLink, experiments } = this.props
    let isShowingCloseButton = detectWebviewOs() !== OsTypes.NONE

    if (experiments.dropshipping_status || experiments.bank_onboarding) {
      isShowingCloseButton = false
    }

    return (
      <React.Fragment>
        {this.state.needsActivation && (
          <React.Fragment>
            <Button
              accessibilityLabel={t.navTitle()}
              isInline
              type={Button.Types.FlatPrimary}
              onClick={() => {
                this.setState({ needsActivation: false })
              }}
            >
              <NavBar>
                <Inline size={Inline.Sizes.XSmall}>
                  <NavIcon>
                    <Icon type={Icon.Types.ArrowLeft} />
                  </NavIcon>
                </Inline>
                <Text styles={Text.Styles.NavBarTitle}>{t.navTitle()}</Text>
              </NavBar>
            </Button>
          </React.Fragment>
        )}

        <Wrapper>
          {isShowingCloseButton && (
            <CloseButton>
              <Icon type={Icon.Types.Close} onClick={this.handleClose} />
            </CloseButton>
          )}
          <RedCardActivate
            dasherId={dasherId}
            onActivate={this.onActivate}
            returnLink={returnLink}
          />
        </Wrapper>
      </React.Fragment>
    )
  }

  private handleClose = () => {
    const { trackRedCardActivateClosed } = this.props
    const os = detectWebviewOs()
    if (os === OsTypes.Android) {
      trackRedCardActivateClosed()
      window.location.assign(ANDROID_CLOSE_DEEPLINK)
      return
    }

    if (os === OsTypes.iOS) {
      trackRedCardActivateClosed()
      window.location.assign(IOS_CLOSE_DEEPLINK)
    }
  }

  private onActivate = () => {
    const os = detectWebviewOs()
    if (os === OsTypes.Android) {
      window.location.assign(ANDROID_REDCARD_DEEPLINK)
      return
    }

    if (os === OsTypes.iOS) {
      window.location.assign(IOS_REDCARD_DEEPLINK)
      return
    }

    // If on desktop/mobile web, return to dropshipping status
    window.location.reload(true)
  }
}

const mapStateToProps = state => ({
  experiments: state.experiments,
})
const mapDispatchToProps = {
  trackRedCardActivateClosed: events.trackRedCardActivateClosed,
}
export default connect(mapStateToProps, mapDispatchToProps)(RedCard)
